import {HeroCalendarDaysIcon} from 'components/Icon'
import React from 'react'
import {isCurrentYear} from 'utils/datetime'
import {styled} from 'stitches/config'
import {useTranslation} from 'react-i18next'

const StyledDivider = styled('div', {
    '&::before, &::after': {
        backgroundColor: '$hrBorderLight',
        content: '""',
        flex: 1,
        height: '1px',
    },
    'alignItems': 'center',
    'display': 'flex',
    'fontSize': '0.85rem',
    'justifyContent': 'center',
    'margin': '1rem 0 0',
    'width': '100%',
})

const StyledContent = styled('div', {
    color: '$smallText',
    display: 'flex',
    gap: '0.2rem',
})

const StyledTime = styled('time', {})

const DateDivider = ({timestamp = 0}: { timestamp: number }): React.ReactElement => {
    const {i18n} = useTranslation()
    const date = new Date(timestamp * 1000)
    const showYear = !isCurrentYear(date)

    const [isoDate] = date.toISOString().split('T') ?? []

    const formatted = new Intl.DateTimeFormat(i18n.language, {
        day: 'numeric',
        month: 'long',
        ...showYear && {year: 'numeric'},
    }).format(date)

    return (
        <StyledDivider>
            <StyledContent>
                <HeroCalendarDaysIcon size={18} />
                <StyledTime dateTime={isoDate}>{formatted}</StyledTime>
            </StyledContent>
        </StyledDivider>
    )
}

export default DateDivider
